// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-v2/accolades-list-v2.component.scss
// module id = 766
// module chunks = 0